var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-16",attrs:{"fluid":""}},[_c('iframe',{attrs:{"src":"https://www.17track.net/es","width":"100%","height":"500px","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }